import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryProvider } from './providers/QueryProvider';
import './index.css';

// Prevent right-click context menu in webview
document.addEventListener('contextmenu', (e) => {
  e.preventDefault();
});

// Prevent text selection in webview
document.addEventListener('selectstart', (e) => {
  e.preventDefault();
});

// Prevent drag and drop
document.addEventListener('dragstart', (e) => {
  e.preventDefault();
});

// Performance monitoring for webview
if (import.meta.env.DEV) {
  console.log('🚀 Amanora Tally Billing App - Development Mode');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </React.StrictMode>
);